import { QRCode } from '@theme/qr-code-generator';

const root = document.querySelector('#instame-in-store-ipad');
if (root) {
  const qaThemeId = root.dataset.qaThemeId;
  const hillsdale = new URL(location.origin).hostname === 'hillsdale.lilaland.co' || new URL(location.origin).hostname === 'h9pw2h-fy.myshopify.com';
  if (root.dataset.orderMode !== 'phone' && (hillsdale || /^\d{10,}$/.test(qaThemeId || ''))) {
    // Use the page actually running this station. Copied stores need not have
    // the original popup page; Shopify's alternate view supplies photo upload.
    const url = new URL(hillsdale ? '/pages/station' : location.pathname || '/pages/popup', location.origin);
    url.searchParams.set('view', 'in-store-photo');
    url.searchParams.set('station', root.dataset.stationNumber || '1');
    if(qaThemeId)url.searchParams.set('preview_theme_id', qaThemeId);
    const update = () => {
      const old = root.querySelector('img.in-store-ipad__qr');
      if (!old) return;
      const holder = document.createElement('div');
      holder.className = 'in-store-ipad__qr';
      holder.setAttribute('role', 'img');
      holder.setAttribute('aria-label', 'QR code to send a pet photo');
      new QRCode(holder, { text: url.href, useSVG: true, correctLevel: QRCode.CorrectLevel.M });
      old.replaceWith(holder);
    };
    // Upload instructions now live in a dialog beside the page content.
    new MutationObserver(update).observe(root, { childList: true, subtree: true });
    update();
  }
}
